import WebsiteEntertainmentModel from '@models/website/WebsiteEntertainmentModel';
import doc                       from '@widesk-core/decorators/doc';
import WebsiteServiceModel       from '@/models/WebsiteServiceModel';
import Blamable                  from '@/models/traits/Blamable';
import { Addable }               from '@widesk-core/decorators/addable';
import { Editable }              from '@widesk-core/decorators/editable';
import { Deletable }             from '@widesk-core/decorators/deletable';
import { Timestampable }         from '@widesk-core/decorators/timestampable';

@doc.path('/timed_notifications/{?id}')
@doc.addable
@doc.editable
@doc.deletable
@doc.timestampable
abstract class AbstractTimedNotificationModel extends Blamable(
	WebsiteServiceModel,
) {
	declare protected _tsFilters: {
		'partial': string;
		'createdAt[before]': string | Date;
		'createdAt[strictly_before]': string | Date;
		'createdAt[after]': string | Date;
		'createdAt[strictly_after]': string | Date;
		'updatedAt[before]': string | Date;
		'updatedAt[strictly_before]': string | Date;
		'updatedAt[after]': string | Date;
		'updatedAt[strictly_after]': string | Date;
		'sendAt[before]': id;
		'sendAt[strictly_before]': id;
		'sendAt[after]': id;
		'sendAt[strictly_after]': id;
		'websiteEntertainment': id;
	};

	declare private _tsSorts: {
		id: string;
		sendAt: string;
		createdAt: string;
		updatedAt: string;
	};

	@doc.model(WebsiteEntertainmentModel)
	declare websiteEntertainment: WebsiteEntertainmentModel;
	@doc.date declare sendAt: Dayjs;
}

interface AbstractTimedNotificationModel
	extends Addable,
		Editable,
		Deletable,
		Timestampable {}

export default AbstractTimedNotificationModel;
